<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList">
        <a-date-picker v-model="workDateObj" slot="datePicker" @change="handleWorkDateChange" />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvWorkCapacity4plNewExport" ref="download" />
        <a-button type="primary" @click="handleExport" v-hasPermi="['inv:invWorkCapacity4pl:export']" :loading="isExportBtnLoading">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.WORK_CAPACITY_LIST, // 表格方案配置唯一值
              }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetWorkCapacity4plList, apiInvWorkCapacity4plNewExport } from '@/api/mes/scheduling-plan/work-capacity'
import { generateLsTableResData } from '@/utils/util.js';
import moment from 'moment'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Work-capacity', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiInvWorkCapacity4plNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetWorkCapacity4plList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
				workDate: undefined,
				deviceName: undefined,
				warehouseName: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
				{
					label: '工作时间',
					type: 'datePicker'
				},
				{
					label: '设备名称',
					decorator: ['deviceName'],
					type: 'input'
				},
        {
          label: '仓库名称',
          decorator: ['warehouseName'],
					type: 'input'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '仓库名称',
          dataIndex: 'warehouseName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '仓库编码',
          dataIndex: 'warehouseCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '工作时间',
          dataIndex: 'workDate',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '设备编码',
          dataIndex: 'deviceCode',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '设备数量',
          dataIndex: 'deviceNumber',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '设备效率',
          dataIndex: 'deviceEfficiency',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '设备总效率',
          dataIndex: 'deviceTotalEfficiency',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '工作时长',
          dataIndex: 'workHours',
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ],
      workDateObj: null,
      isExportBtnLoading: false
    }
  },
  created () {},
  mounted () {
    // 设置工作时间默认值为次日
    this.workDateObj = moment().add(1, 'days')
    this.handleWorkDateChange(this.workDateObj, this.workDateObj.format('YYYY-MM-DD'))
    // 初始化数据
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
				workDate: undefined,
				deviceName: undefined,
				warehouseName: undefined
      }
      this.workDateObj = null
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
		handleWorkDateChange (date, dateString) {
			this.queryParams.workDate = dateString
		},
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
      // this.isExportBtnLoading = true
      // this.download('inv/invWorkCapacity4pl/export', {
      //   ...this.$refs.dataTable.searchParams
      // }, `作业能力_${new Date().getTime()}.xlsx`).then(res => {
      //   this.isExportBtnLoading = false
      // }).catch(() => {
      //   this.isExportBtnLoading = false
      // })
    }
  }
}
</script>

<style scoped lang="less"></style>
